import InfoApi from "./Info";

export const infoApi = new InfoApi();
